import { state } from '../state'
import { ensureCurrentPlayerBuild } from './build-service'
import { updateEntities } from './entity-service'
import { getRunEndRoute } from './quest-bridge'

export const environmentHostName = window.location.hostname.includes('-') ? window.location.hostname : ''

let initialized = false

export function reset() {
  initialized = false
}

export async function handleNavigation(path: string) {
  const { user, organizationId } = state
  if (!user || !organizationId || initialized) {
    return
  }
  const updateEntitiesPromise = updateEntities(true)
  await ensureCurrentPlayerBuild()
  if (Object.keys(state.courses).length === 0) {
    await updateEntitiesPromise
  }
  initialized = true
  const runEndRoute = await getRunEndRoute(path)
  if (runEndRoute) {
    return runEndRoute
  }
}
